import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import {Landing, EvaluationForm, Dashboard, Contest} from './pages';


function Routes() {
  return (
    <BrowserRouter>
      <Route path="/" exact component={Landing} />
      <Route path="/concurso/:id/:title" component={EvaluationForm} />
      <Route path="/dashboard/:id/:title" component={Dashboard} />
      <Route path="/contest" component={Contest} />
    </BrowserRouter>
  );
}

export default Routes;
